import { createContext, ReactNode, useState } from 'react';

interface MergedAnsweredItemsEnabledContextProps {
  children: ReactNode;
}

interface MergedAnsweredItemsEnabledContextData {
  mergedAnsweredItemsEnabled: boolean;
  setMergedAnsweredItemsEnabled: (mergedAnsweredItemsEnabled: boolean) => void;
}

export const MergedAnsweredItemsEnabledContext = createContext(
  {} as MergedAnsweredItemsEnabledContextData
);

export function MergedAnsweredItemsEnabledProvider({
  children,
}: MergedAnsweredItemsEnabledContextProps) {
  const [mergedAnsweredItemsEnabled, setMergedAnsweredItemsEnabled] =
    useState<boolean>(true);
  return (
    <MergedAnsweredItemsEnabledContext.Provider
      value={
        {
          mergedAnsweredItemsEnabled: mergedAnsweredItemsEnabled,
          setMergedAnsweredItemsEnabled: setMergedAnsweredItemsEnabled,
        } as MergedAnsweredItemsEnabledContextData
      }
    >
      {children}
    </MergedAnsweredItemsEnabledContext.Provider>
  );
}
